import React from 'react';
import { Container } from 'react-bootstrap';
import OrgTimeline from "../components/OrgTimeline";

const About = ({ darkMode }) => {
    return (
        <Container style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <h2 className="text-center mb-3" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                Our Journey
            </h2>
            <p className="text-center mb-4" style={{ maxWidth: '900px', margin: '0 auto', fontSize: '1.05rem' }}>
                Founded in 2003, Pruthvisangram Gramvikas Sanstha has grown from a grassroots voluntary
                organization in Kadepur, Sangli into a vibrant force for change — reaching more than 3,869 villages
                across 13 districts of Maharashtra. Here is a look at our milestones over the years.
            </p>
            <h3 className="mt-4 mb-3" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>PSGS Timeline</h3>
            <OrgTimeline darkMode={darkMode} />
        </Container>
    );
};

export default About;
